import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { t } from 'ember-intl';
/**
 *
 * `NetworksCidrRecommendations` contain the list of recommendations on selecting an appropriate CIDR block for an HVN.
 *
 *
 * ```
 * <NetworksCidrRecommendations />
 * ```
 *
 * @class NetworksCidrRecommendations
 *
 */ export default class NetworksCidrRecommendations extends Component {
    static{
        template(`
    <ul class="bulleted" data-test-network-create-network-cidr-recommendations>
      <li>
        {{t
          "components.networks.cidr-recommendations.no-overlap"
          htmlSafe=true
          provider=@provider
        }}
      </li>
      <li>
        <span>
          {{t
            "components.networks.cidr-recommendations.change-default"
            htmlSafe=true
            provider=@provider
          }}
        </span>
      </li>
      <li>
        <span>
          {{t
            "components.networks.cidr-recommendations.address-space"
            htmlSafe=true
          }}
        </span>
      </li>
      <li>
        {{t "components.networks.cidr-recommendations.first-address"}}
      </li>
      <li>
        <span>
          {{t
            "components.networks.cidr-recommendations.prefix-range"
            htmlSafe=true
          }}
        </span>
      </li>
    </ul>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci9hY3Rpb25zLXJ1bm5lci9fd29yay9jbG91ZC11aS9jbG91ZC11aS9hZGRvbnMvbmV0d29ya3MtY29tbW9uL3BhY2thZ2Uvc3JjL2NvbXBvbmVudHMvbmV0d29ya3MvY2lkci1yZWNvbW1lbmRhdGlvbnMuZ2pzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBDb21wb25lbnQgZnJvbSAnQGdsaW1tZXIvY29tcG9uZW50JztcbmltcG9ydCB7IHQgfSBmcm9tICdlbWJlci1pbnRsJztcblxuLyoqXG4gKlxuICogYE5ldHdvcmtzQ2lkclJlY29tbWVuZGF0aW9uc2AgY29udGFpbiB0aGUgbGlzdCBvZiByZWNvbW1lbmRhdGlvbnMgb24gc2VsZWN0aW5nIGFuIGFwcHJvcHJpYXRlIENJRFIgYmxvY2sgZm9yIGFuIEhWTi5cbiAqXG4gKlxuICogYGBgXG4gKiA8TmV0d29ya3NDaWRyUmVjb21tZW5kYXRpb25zIC8-XG4gKiBgYGBcbiAqXG4gKiBAY2xhc3MgTmV0d29ya3NDaWRyUmVjb21tZW5kYXRpb25zXG4gKlxuICovXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIE5ldHdvcmtzQ2lkclJlY29tbWVuZGF0aW9ucyBleHRlbmRzIENvbXBvbmVudCB7XG4gIDx0ZW1wbGF0ZT5cbiAgICA8dWwgY2xhc3M9XCJidWxsZXRlZFwiIGRhdGEtdGVzdC1uZXR3b3JrLWNyZWF0ZS1uZXR3b3JrLWNpZHItcmVjb21tZW5kYXRpb25zPlxuICAgICAgPGxpPlxuICAgICAgICB7e3RcbiAgICAgICAgICBcImNvbXBvbmVudHMubmV0d29ya3MuY2lkci1yZWNvbW1lbmRhdGlvbnMubm8tb3ZlcmxhcFwiXG4gICAgICAgICAgaHRtbFNhZmU9dHJ1ZVxuICAgICAgICAgIHByb3ZpZGVyPUBwcm92aWRlclxuICAgICAgICB9fVxuICAgICAgPC9saT5cbiAgICAgIDxsaT5cbiAgICAgICAgPHNwYW4-XG4gICAgICAgICAge3t0XG4gICAgICAgICAgICBcImNvbXBvbmVudHMubmV0d29ya3MuY2lkci1yZWNvbW1lbmRhdGlvbnMuY2hhbmdlLWRlZmF1bHRcIlxuICAgICAgICAgICAgaHRtbFNhZmU9dHJ1ZVxuICAgICAgICAgICAgcHJvdmlkZXI9QHByb3ZpZGVyXG4gICAgICAgICAgfX1cbiAgICAgICAgPC9zcGFuPlxuICAgICAgPC9saT5cbiAgICAgIDxsaT5cbiAgICAgICAgPHNwYW4-XG4gICAgICAgICAge3t0XG4gICAgICAgICAgICBcImNvbXBvbmVudHMubmV0d29ya3MuY2lkci1yZWNvbW1lbmRhdGlvbnMuYWRkcmVzcy1zcGFjZVwiXG4gICAgICAgICAgICBodG1sU2FmZT10cnVlXG4gICAgICAgICAgfX1cbiAgICAgICAgPC9zcGFuPlxuICAgICAgPC9saT5cbiAgICAgIDxsaT5cbiAgICAgICAge3t0IFwiY29tcG9uZW50cy5uZXR3b3Jrcy5jaWRyLXJlY29tbWVuZGF0aW9ucy5maXJzdC1hZGRyZXNzXCJ9fVxuICAgICAgPC9saT5cbiAgICAgIDxsaT5cbiAgICAgICAgPHNwYW4-XG4gICAgICAgICAge3t0XG4gICAgICAgICAgICBcImNvbXBvbmVudHMubmV0d29ya3MuY2lkci1yZWNvbW1lbmRhdGlvbnMucHJlZml4LXJhbmdlXCJcbiAgICAgICAgICAgIGh0bWxTYWZlPXRydWVcbiAgICAgICAgICB9fVxuICAgICAgICA8L3NwYW4-XG4gICAgICA8L2xpPlxuICAgIDwvdWw-XG4gIDwvdGVtcGxhdGU-XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sZUFBZSxxQkFBcUI7QUFDM0MsU0FBUyxDQUFDLFFBQVEsYUFBYTtBQUUvQjs7Ozs7Ozs7Ozs7Q0FXQyxHQUVELGVBQWUsTUFBTSxvQ0FBb0M7SUFDdkQsTUFBQTtRQUFBLFNBQVUsQ0FBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7RUFzQ1YsQ0FBQSxFQUFBO1lBQUEsV0FBQSxJQUFXO1lBQVg7Z0JBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO1lBQUQ7UUFBQTtJQUFBLENBdENBO0FBdUNaIn0